import { ComponentPublicInstance } from 'vue';
import openModal from './index';
import ConfirmModal from './ConfirmModal.vue';
import PromptModal from './PromptModal.vue';

interface ConfirmOptions {
  title?: string;
  message: string;
  cancel?: boolean;
  parent?: ComponentPublicInstance;
}

interface PromptOptions {
  title?: string;
  label?: string;
  isValid?: (v: string) => boolean;
  parent?: ComponentPublicInstance;
}

// export const dialog = {
export function confirm(options: ConfirmOptions) {
  return openModal(ConfirmModal, {
    parent: options.parent,
    title: options.title || 'Confirm',
    message: options.message,
    cancel: options.cancel !== false,
  });
}

export function prompt(options: PromptOptions) {
  return openModal(PromptModal, {
    parent: options.parent,
    title: options.title || 'Input',
    label: options.label || '',
    isValid: options.isValid || ((v: string) => v.length > 0),
  });
}

// };
